export const System = () => {
    return (
        <div>System</div>
    );
}